export enum UTMAnswer {
  DIRECT = 'Direct',
  FACEBOOK = 'Facebook',
  LG = 'LG',
  GOOGLE = 'Google',
  FB_MESSENGER = 'Facebook Messenger',
  INSTAGRAM = 'Instagram',
  KIESKEURIG = 'Kieskeurig',
  LGAIRCOKOPEN = 'LG Airco Kopen',
  QUESTIONNAIRE = 'Questionnaire',
}
